
(function () {
  'use strict';

  var overlay = document.getElementById('sp-overlay');
  var modal    = document.getElementById('sp-modal');
  var closeBtn = document.getElementById('sp-close');
  var tab      = document.getElementById('sp-tab');
  var tabOpen  = document.getElementById('sp-tab-open');
  var tabKill  = document.getElementById('sp-tab-kill');

  if (!overlay || !modal) return;

  var STORAGE_KEY = 'sp_state_v1_' + (overlay.dataset.shopId || 'default');
  var DELAY = parseInt(overlay.dataset.delay, 10);
  if (isNaN(DELAY)) DELAY = 2000;

  function getState() {
    try { return window.localStorage.getItem(STORAGE_KEY); }
    catch (e) { return null; }
  }
  function setState(value) {
    try { window.localStorage.setItem(STORAGE_KEY, value); }
    catch (e) { /* storage unavailable — popup still works for this pageview */ }
  }

  function openPopup() {
    overlay.classList.add('sp-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sp-locked');
    setTimeout(function () {
      var el = modal.querySelector('a[href], button');
      if (el) el.focus();
    }, 320);
  }

  function closePopup() {
    overlay.classList.remove('sp-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sp-locked');
    setState('seen');
    showTab();
  }

  function showTab() {
    if (!tab) return;
    tab.style.display = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        tab.classList.add('sp-tab-visible');
      });
    });
  }

  function killTab(e) {
    if (e) e.stopPropagation();
    setState('killed');
    tab.classList.remove('sp-tab-visible');
    tab.style.display = 'none';
  }

  var state = getState();

  if (state === 'killed') {
    if (tab) tab.style.display = 'none';
    return;
  }

  if (state === 'seen') {
    showTab();
  } else {
    setTimeout(openPopup, DELAY);
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27)
        && overlay.classList.contains('sp-open')) {
      closePopup();
    }
  });

  if (tabOpen) tabOpen.addEventListener('click', openPopup);

  if (tabKill) {
    tabKill.addEventListener('click', killTab);
    tabKill.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        killTab(e);
      }
    });
  }

})();
